import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollService } from '../../core/scroll.service';
import { AccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { RoutesService } from '../../api/routes.service';
import { AuthService } from '../../api/auth.service';
import { PassValConstraint } from '../../api/constants/password-validation';

@Component({
  selector: 'password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit, OnDestroy {

  constructor(
    public lang: LangService,
    private loginGuard: LoginGuardService, //
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private routes: RoutesService,
    private scrollService: ScrollService,
  ) { }

  public breadcrumb = [];
  public isFormValidated: boolean;
  public emailEncoded: string;
  public resetKey: string;
  private routeSub: Subscription;
  private userSub: Subscription;

  public formGroup = new FormGroup({
    password: new FormControl(),
    passwordConfirm: new FormControl(),
  });

  activeFormError: string;

  isPasswordPolicyShowing: boolean;

  ngOnInit() {
    this.loginGuard.deactivate();
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.emailEncoded = routeParams['emailEncoded'];
      this.resetKey = routeParams['resetKey'];
      this.initRouteView();
    });
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  initRouteView() {
    this.breadcrumb = [
      this.breadcrumbsService.HOME(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_password_reset'), this.router.url),
    ];
    // console.log(this.emailEncoded, this.resetKey)
    this.formGroup.controls.password.valueChanges.subscribe(v => this.clearErrorReport());
    this.formGroup.controls.passwordConfirm.valueChanges.subscribe(v => this.clearErrorReport());
  }
  reportFormError(slug: string) {
    console.log('form error', slug);
    this.activeFormError = slug;
  }

  clearErrorReport() {
    this.activeFormError = null;
  }

  enableInput() {
    this.formGroup.enable();
    this.formGroup.controls.password.enable();
    this.formGroup.controls.passwordConfirm.enable();
  }
  disableInput() {
    this.formGroup.disable();
    this.formGroup.controls.password.disable();
    this.formGroup.controls.passwordConfirm.disable();
  }

  submitForm() {
    if (this.isFormValidated) {
      return;
    }
    const password = this.formGroup.controls.password.value;
    const passwordConfirm = this.formGroup.controls.passwordConfirm.value;
    if (!password) {
      this.reportFormError('txt_pass_reset_no_pass');
      return;
    }
    if (password !== passwordConfirm) {
      this.reportFormError('txt_pass_reset_mismatch_pass');
      return;
    }

    this.disableInput();

    const email = decodeURIComponent(this.emailEncoded);
    const reset_token = this.resetKey;
    const new_password = password;

    this.auth
      .apiPatch(
        this.routes.AUTH_RESET_PASSWORD,
        null,
        {
          email,
          reset_token,
          new_password
        }
      )
      .then(noInfoRes => {
        this.scrollService.scrollToTop();
        this.isFormValidated = true;
        this.auth
          .logout()
          .then( () => {
            this.userSub = this.auth.user().subscribe(u => this.loginGuard.gotoUserDashboard(u));
          });
      })
      .catch(e => {
        this.enableInput();
        this.reportFormError(this.parseErrorMessage(e.message));
      });
  }

  parseErrorMessage(message: string) {
    switch (message) {
      case PassValConstraint.PASS_VALC_MIN_CHARS: return 'txt_pass_reset_invalid_pass_min';
      case PassValConstraint.PASS_VALC_MAX_CHARS: return 'txt_pass_reset_invalid_pass_max';
      case PassValConstraint.PASS_VALC_UPPERCASE: return 'txt_pass_reset_invalid_pass_upper';
      case PassValConstraint.PASS_VALC_LOWERCASE: return 'txt_pass_reset_invalid_pass_lower';
      case PassValConstraint.PASS_VALC_NUMBER   : return 'txt_pass_reset_invalid_pass_number';
      case PassValConstraint.PASS_VALC_SYMBOL   : return 'txt_pass_reset_invalid_pass_symbol';
           default                              :
      case 'EXPIRED_RESET_TOKEN'                : return 'txt_pass_reset_invalid_code';
    }
  }
  togglePasswordPolicy() {
    this.isPasswordPolicyShowing = !this.isPasswordPolicyShowing;
  }

  login() {
    const email = decodeURIComponent(this.emailEncoded);
    const password = this.formGroup.controls.password.value;
    this.auth.login(email, password);
  }

  continueIntoSite() {

  }

}
